export const STR_ERRORS = {
    NoConnectionsAvailable: "No connection class was found, did you initialize the data layer?",
    ReachedTimeLimitForOpeningConnection: "Reched the time limit for openning a connection",
    NoMessageBus: "Wrong configuration! Please provide the message bus",
    NoConnectionUrls: "Wrong configuration! Please provide connection URLs",
    MaxNumberOfRetriesExceeded: "A request was not send due to missing authorization, or network down in the allotted time limit",
    SameMessageAlreadyPending: "Same request is already pending. Message won't be repeated",
    EmptyResponse: "Empty or unreadable response",
    InvalidBaseUrl: "Invalid base URL",
    NoChannel: "Channel was not found",
    NoChannelMappingForConnection: "Connection does not have channel mapping"
};
export const STR = {};
//# sourceMappingURL=index.js.map